export const getPasswordRequirements = (pwd) => ({
  symbol: /[^A-Za-z0-9]/.test(pwd),
  uppercase: /[A-Z]/.test(pwd),
  lowercase: /[a-z]/.test(pwd),
  number: /[0-9]/.test(pwd),
  minLength: pwd.length >= 8,
});

export const PASSWORD_REQUIREMENT_KEYS = [
  "symbol",
  "uppercase",
  "lowercase",
  "number",
  "minLength",
];
